<section class="relative overflow-hidden bg-white py-24 dark:bg-shl-navy">
  <div class="mx-auto max-w-7xl px-6 lg:px-8">
    <div class="mb-16 text-center">
      <span
        class="rounded-full bg-blue-50 px-3 py-1 text-xs font-bold uppercase text-shl-sky dark:bg-shl-sky/20 dark:text-blue-300"
      >
        {{ 'global_network.eyebrow' | translate }}
      </span>
      <h2 class="mt-3 text-3xl font-black text-shl-navy dark:text-white sm:text-4xl">
        {{ 'global_network.title' | translate }}
      </h2>
      <p class="mt-4 text-gray-500 dark:text-gray-400">
        {{ 'global_network.description' | translate }}
      </p>
    </div>
    <div
      class="relative w-screen sm:w-full aspect-[2/1] sm:aspect-auto sm:min-h-[440px] lg:min-h-[520px] overflow-hidden rounded-none sm:rounded-3xl sm:rounded-tr-[60px] bg-slate-50 border border-slate-200 shadow-inner -mx-[calc(50vw-50%)] sm:mx-0"
    >
      <img
        [attr.alt]="'global_network.map_alt' | translate"
        title="{{ 'global_network.map_alt' | translate }}"
        class="absolute inset-0 h-full w-full object-cover object-center opacity-30"
        [attr.data-location]="'global_network.map_location_label' | translate"
        src="https://lh3.googleusercontent.com/aida-public/AB6AXuBPQXpgPskvSvLXXtTGySE65FZb0AoDU2xeaNaywxvO5knS4pDnit18ALNmy2NYt9z5mJAin-vjQtTWoNPQrowg_tpQpRI8ZKG-PW_f0XvCvmvTqco90WsLCBD_UAAx_YfN9vYEE6rdBL2xcC99RbK3uZgzDobhWEcpgHCamhoDO9FWhVPAyyLT0vJWtoJwCmmzxJAMN28c_uvUePhqQZ1Zlwb34Pdj3PGC4vrPFA528dbDp8ueuezB65snZO6OqQ5iUesmdwPQRvcw"
      />
      <div class="absolute inset-0 flex items-center justify-center">
        <svg class="absolute hidden h-full w-full sm:block" preserveAspectRatio="xMidYMid slice" viewBox="0 0 800 400">
          <g fill="none" stroke-linecap="round" stroke-width="2">
            <path d="M 395 165 Q 310 -10 100 100" stroke="#F59E0B" stroke-dasharray="4 4" class="opacity-80">
              <animate attributeName="stroke-dashoffset" dur="2.8s" from="120" repeatCount="indefinite" to="0"></animate>
            </path>
            <path d="M 395 165 Q 280 60 180 125" stroke="#F59E0B" stroke-dasharray="4 4" class="opacity-80">
              <animate attributeName="stroke-dashoffset" dur="2.7s" from="120" repeatCount="indefinite" to="0"></animate>
            </path>
            <path d="M 395 165 Q 260 200 150 170" stroke="#F59E0B" stroke-dasharray="4 4" class="opacity-80">
              <animate attributeName="stroke-dashoffset" dur="2.9s" from="120" repeatCount="indefinite" to="0"></animate>
            </path>
            <path d="M 395 165 Q 300 380 250 320" stroke="#F59E0B" stroke-dasharray="4 4" class="opacity-70">
              <animate attributeName="stroke-dashoffset" dur="3s" from="120" repeatCount="indefinite" to="0"></animate>
            </path>

            <path d="M 395 165 Q 380 100 395 130" stroke="#10B981" stroke-dasharray="4 4" class="opacity-80">
              <animate attributeName="stroke-dashoffset" dur="2.4s" from="110" repeatCount="indefinite" to="0"></animate>
            </path>
            <path d="M 395 165 Q 450 115 435 110" stroke="#10B981" stroke-dasharray="4 4" class="opacity-80">
              <animate attributeName="stroke-dashoffset" dur="2.4s" from="110" repeatCount="indefinite" to="0"></animate>
            </path>
            <path d="M 395 165 Q 455 125 580 100" stroke="#10B981" stroke-dasharray="4 4" class="opacity-80">
              <animate attributeName="stroke-dashoffset" dur="2.5s" from="110" repeatCount="indefinite" to="0"></animate>
            </path>

            <path d="M 395 165 Q 470 165 470 180" stroke="#008DD2" stroke-dasharray="4 4" class="opacity-80">
              <animate attributeName="stroke-dashoffset" dur="2.3s" from="100" repeatCount="indefinite" to="0"></animate>
            </path>
            <path d="M 395 165 Q 470 215 480 210" stroke="#008DD2" stroke-dasharray="4 4" class="opacity-80">
              <animate attributeName="stroke-dashoffset" dur="2.3s" from="100" repeatCount="indefinite" to="0"></animate>
            </path>

            <path d="M 395 165 Q 560 150 600 190" stroke="#8B5CF6" stroke-dasharray="4 4" class="opacity-70">
              <animate attributeName="stroke-dashoffset" dur="3s" from="130" repeatCount="indefinite" to="0"></animate>
            </path>
            <path d="M 395 165 Q 620 420 650 260" stroke="#8B5CF6" stroke-dasharray="4 4" class="opacity-60">
              <animate attributeName="stroke-dashoffset" dur="3.1s" from="130" repeatCount="indefinite" to="0"></animate>
            </path>

            <path d="M 395 165 Q 405 210 385 215" stroke="#F97316" stroke-dasharray="4 4" class="opacity-60">
              <animate attributeName="stroke-dashoffset" dur="2.8s" from="120" repeatCount="indefinite" to="0"></animate>
            </path>
            <path d="M 395 165 Q 445 250 425 320" stroke="#F97316" stroke-dasharray="4 4" class="opacity-60">
              <animate attributeName="stroke-dashoffset" dur="2.9s" from="120" repeatCount="indefinite" to="0"></animate>
            </path>
          </g>
          <circle cx="395" cy="165" r="5" fill="#0C3B63"></circle>
          <circle cx="395" cy="165" r="15" fill="#0C3B63" opacity="0.25">
            <animate attributeName="r" dur="2.4s" repeatCount="indefinite" values="12;22;12"></animate>
            <animate attributeName="opacity" dur="2.4s" repeatCount="indefinite" values="0.25;0;0.25"></animate>
          </circle>
        </svg>
        <svg class="absolute h-full w-full sm:hidden" preserveAspectRatio="xMidYMid slice" viewBox="0 0 800 400">
          <g fill="none" stroke-linecap="round" stroke-width="2">
            <path d="M 395 165 Q 310 -10 100 100" stroke="#F59E0B" stroke-dasharray="4 4" class="opacity-80">
              <animate attributeName="stroke-dashoffset" dur="2.8s" from="120" repeatCount="indefinite" to="0"></animate>
            </path>
            <path d="M 395 165 Q 280 60 180 125" stroke="#F59E0B" stroke-dasharray="4 4" class="opacity-80">
              <animate attributeName="stroke-dashoffset" dur="2.7s" from="120" repeatCount="indefinite" to="0"></animate>
            </path>
            <path d="M 395 165 Q 260 200 150 170" stroke="#F59E0B" stroke-dasharray="4 4" class="opacity-80">
              <animate attributeName="stroke-dashoffset" dur="2.9s" from="120" repeatCount="indefinite" to="0"></animate>
            </path>
            <path d="M 395 165 Q 300 380 250 320" stroke="#F59E0B" stroke-dasharray="4 4" class="opacity-70">
              <animate attributeName="stroke-dashoffset" dur="3s" from="120" repeatCount="indefinite" to="0"></animate>
            </path>

            <path d="M 395 165 Q 380 100 395 130" stroke="#10B981" stroke-dasharray="4 4" class="opacity-80">
              <animate attributeName="stroke-dashoffset" dur="2.4s" from="110" repeatCount="indefinite" to="0"></animate>
            </path>
            <path d="M 395 165 Q 450 115 435 110" stroke="#10B981" stroke-dasharray="4 4" class="opacity-80">
              <animate attributeName="stroke-dashoffset" dur="2.4s" from="110" repeatCount="indefinite" to="0"></animate>
            </path>
            <path d="M 395 165 Q 455 125 580 100" stroke="#10B981" stroke-dasharray="4 4" class="opacity-80">
              <animate attributeName="stroke-dashoffset" dur="2.5s" from="110" repeatCount="indefinite" to="0"></animate>
            </path>

            <path d="M 395 165 Q 470 165 470 180" stroke="#008DD2" stroke-dasharray="4 4" class="opacity-80">
              <animate attributeName="stroke-dashoffset" dur="2.3s" from="100" repeatCount="indefinite" to="0"></animate>
            </path>
            <path d="M 395 165 Q 470 215 480 210" stroke="#008DD2" stroke-dasharray="4 4" class="opacity-80">
              <animate attributeName="stroke-dashoffset" dur="2.3s" from="100" repeatCount="indefinite" to="0"></animate>
            </path>

            <path d="M 395 165 Q 560 150 600 190" stroke="#8B5CF6" stroke-dasharray="4 4" class="opacity-70">
              <animate attributeName="stroke-dashoffset" dur="3s" from="130" repeatCount="indefinite" to="0"></animate>
            </path>
            <path d="M 395 165 Q 620 420 650 260" stroke="#8B5CF6" stroke-dasharray="4 4" class="opacity-60">
              <animate attributeName="stroke-dashoffset" dur="3.1s" from="130" repeatCount="indefinite" to="0"></animate>
            </path>

            <path d="M 395 165 Q 405 210 385 215" stroke="#F97316" stroke-dasharray="4 4" class="opacity-60">
              <animate attributeName="stroke-dashoffset" dur="2.8s" from="120" repeatCount="indefinite" to="0"></animate>
            </path>
            <path d="M 395 165 Q 445 250 425 320" stroke="#F97316" stroke-dasharray="4 4" class="opacity-60">
              <animate attributeName="stroke-dashoffset" dur="2.9s" from="120" repeatCount="indefinite" to="0"></animate>
            </path>
          </g>
          <circle cx="395" cy="165" r="5" fill="#0C3B63"></circle>
          <circle cx="395" cy="165" r="15" fill="#0C3B63" opacity="0.25">
            <animate attributeName="r" dur="2.4s" repeatCount="indefinite" values="12;22;12"></animate>
            <animate attributeName="opacity" dur="2.4s" repeatCount="indefinite" values="0.25;0;0.25"></animate>
          </circle>
        </svg>
      </div>
    </div>
  </div>
</section>
